import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50" data-testid="auth-loading">
        <Loader2 className="w-6 h-6 animate-spin text-emerald-800" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
